export const PULSELEADS_PROSPECT_TITLE = 'title.pulseleads.prospect';
export const PULSELEADS_PROSPECT_CATEGORY_TITLE = 'title.pulseleads.prospect.category';

export const PULSELEADS_PROSPECT_CATEGORY_NAMESPACE = 'PULSELEADS-PROSPECT-CATEGORY';

export const PULSELEADS_LEAD_PROSPECT_PATH = '/prospect';
export const PULSELEADS_LEAD_PROSPECT_CATEGORY_PATH = '/category';
